'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCropOriginal = function ImageCropOriginal(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' })
  );
};
ImageCropOriginal = (0, _pure2.default)(ImageCropOriginal);
ImageCropOriginal.displayName = 'ImageCropOriginal';

exports.default = ImageCropOriginal;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/crop-original.js
 ** module id = 1582
 ** module chunks = 0
 **/